import { hasSupabaseConfig, supabase } from '../../../shared/api/supabaseClient.js';

const ERROR_MESSAGES = {
  missing_authorization: '로그인 세션을 확인할 수 없습니다.',
  invalid_session: '로그인 세션이 만료되었습니다.',
  game_profile_not_found: '연결된 게임 프로필이 없습니다.',
  game_profile_read_failed: '게임 프로필을 불러오지 못했습니다.',
  invalid_stored_openid: '저장된 BlablaLink 프로필 정보를 확인할 수 없습니다.',
  public_profile_unavailable: 'BlablaLink 공개 프로필을 불러오지 못했습니다.',
  public_profile_mismatch: 'BlablaLink 프로필 정보가 연결된 계정과 일치하지 않습니다.',
  blablalink_timeout: 'BlablaLink 응답 시간이 초과되었습니다.',
  blablalink_network_error: 'BlablaLink에 연결하지 못했습니다.',
  avatar_update_failed: '프로필 이미지를 저장하지 못했습니다.',
  server_not_configured: '프로필 이미지 동기화 서버 설정을 확인해주세요.',
};

function requireSupabaseClient() {
  if (!hasSupabaseConfig || !supabase) {
    throw new Error('Supabase 환경 변수가 설정되지 않았습니다.');
  }
  return supabase;
}

async function readFunctionErrorCode(error) {
  try {
    const payload = await error?.context?.json();
    return payload?.code || '';
  } catch {
    return '';
  }
}

function normalizeAvatar(value) {
  if (!value) return null;
  return {
    nickname: String(value.nickname || '').trim(),
    avatarUrl: String(value.avatarUrl || value.avatar_url || '').trim(),
    avatarPendantUrl: String(value.avatarPendantUrl || value.avatar_pendant_url || '').trim(),
    updatedAt: String(value.updatedAt || value.avatar_updated_at || '').trim(),
  };
}

export async function loadStoredBlablaLinkProfileAvatar() {
  const client = requireSupabaseClient();
  const { data: { user }, error: userError } = await client.auth.getUser();
  if (userError || !user?.id) return null;

  const { data, error } = await client
    .from('game_profiles')
    .select('nickname,avatar_url,avatar_pendant_url,avatar_updated_at')
    .eq('user_id', user.id)
    .maybeSingle();

  if (error) throw new Error(ERROR_MESSAGES.game_profile_read_failed);
  return normalizeAvatar(data);
}

export async function syncBlablaLinkProfileAvatar() {
  const client = requireSupabaseClient();
  const { data, error } = await client.functions.invoke('sync-blablalink-profile-avatar', {
    body: {},
  });

  if (error) {
    const code = await readFunctionErrorCode(error);
    const avatarError = new Error(ERROR_MESSAGES[code] || error.message || '프로필 이미지를 갱신하지 못했습니다.');
    avatarError.code = code || 'avatar_sync_failed';
    throw avatarError;
  }

  if (!data?.ok) {
    const code = data?.code || 'avatar_sync_failed';
    const avatarError = new Error(ERROR_MESSAGES[code] || '프로필 이미지를 갱신하지 못했습니다.');
    avatarError.code = code;
    throw avatarError;
  }

  return normalizeAvatar(data.avatar);
}
